import React, {useState, useEffect, useRef} from "react";
import {Popconfirm} from "antd";
import {getISOStringDateToDate} from "../../../_helpers/commonFunctions";
import moment from "moment";

const AcFilterTable = ({
                           ACName,
                           searchKeyword,
                           prevSearchKeyword,
                           tableColumns,
                           tableData,
                           excludeColumns,
                           rowActions,
                           className,
                           selectOption,
                           selectedRowIndex,
                           suppressHover,
                           onRowHover,
                           onMouseMove
                       }) => {
    const [showNotFound, setNotFound] = useState(false);
    const rowRefs = useRef([]);

    useEffect(() => {
        if (selectedRowIndex !== null && rowRefs.current[selectedRowIndex]) {
            const row = rowRefs.current[selectedRowIndex];
            const tableContainer = row.closest('.table-responsive');

            if (selectedRowIndex === 0) {
                tableContainer.scrollTop = 0;
            } else {
                row.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    container: "nearest"
                });
            }
        }
    }, [selectedRowIndex]);

    useEffect(() => {
        if (!tableData || tableData.length <= 0) {
            setNotFound(true);
        } else {
            setNotFound(false);
        }
    }, [tableData])

    const handleDelete = (e, rowKey, row) => {
        rowActions.delete(e, rowKey, row);
    }

    const selectOnClick = (e, tr) => {
        tr && selectOption && selectOption.selected(tr) // pass to parent
    }

    useEffect(() => {
        if (searchKeyword === prevSearchKeyword.current || !prevSearchKeyword?.current) {
            return;
        }
        if (tableData?.length === 1 && searchKeyword?.length > 0) {
            const item = tableData[0];
            if ((ACName === "Sales Client" || ACName === "Buys Supplier") && searchKeyword === item?.vatNumber) {
                item && selectOption?.selected(item);
            } else if (ACName === "name" || ACName === "code") {
                if (
                    item?.code === String(searchKeyword) ||
                    item?.name === String(searchKeyword) ||
                    item?.barcode === String(searchKeyword) ||
                    item?.alternateCode === String(searchKeyword) ||
                    item?.alternateName === String(searchKeyword)
                ) {
                    item && selectOption?.selected(item);
                }
            }
        }
    }, [searchKeyword]);

    return (
        <div onMouseMove={onMouseMove}>
            <div className={className ? className + ' table-responsive' : 'table-responsive'}>
                <table className={`table table-bordered mb-2 ${suppressHover ? 'keyboard-mode' : ''}`}>
                    <thead>
                    <tr>
                        {
                            tableData?.length > 0 && tableColumns.map((col) => (
                                !excludeColumns?.includes(col.name) &&
                                <th className={col.name.toLowerCase()} style={{textAlign: "center"}}
                                    key={Math.random()}>{col.label}</th>
                            ))
                        }
                    </tr>
                    </thead>
                    <tbody>
                    {
                        tableData?.length > 0 ? tableData.map((tr, tri) => (
                                <tr
                                    ref={(el) => (rowRefs.current[tri] = el)}
                                    key={`advCbx${tri}`}
                                    onMouseEnter={() => onRowHover && onRowHover(tri)}
                                    style={
                                        selectedRowIndex === tri
                                            ? { backgroundColor: "#76AEB7", borderColor: "#76AEB7", color: "white" }
                                            : {}
                                    }
                                >
                                    {
                                        tableColumns.map((col) => {
                                            let shownValue = tr[col.name];
                                            if (shownValue === undefined) {
                                                shownValue = "";
                                            } else if (col?.options?.length > 0) {
                                                shownValue = col.options.find((op) => op.value === tr[col.name])?.label;
                                            } else if (col?.name === "creationDateTime") {
                                                shownValue = moment(tr[col.name]).format("DD/MM/YYYY HH:mm");
                                            }
                                            return (
                                                !excludeColumns?.includes(col.name) && (col.name !== 'actions') ?
                                                    <td key={Math.random()}
                                                        style={{
                                                            maxWidth: "350px",
                                                            overflowWrap: "break-word",
                                                            borderColor: selectedRowIndex === tri ? "#76AEB7" : "#dedfe1"
                                                        }}
                                                        className={col.name.toLowerCase()}
                                                        onClick={(e) => selectOnClick(e, tr)}>
                                                        {(col.name === 'date') ? getISOStringDateToDate(tr[col.name]) : (`${tr?.isActive === "inactive" ? "*" : ""}` + shownValue)}
                                                    </td>
                                                    : (col.name === 'actions') && <td key={Math.random()}
                                                                                      className={col.name.toLowerCase() + " text-center"}>
                                                    <Popconfirm
                                                        title="Sure to delete?"
                                                        onConfirm={(e) => handleDelete(e, tri, tr)}
                                                    >
                      <span title='Delete' className="delbtn text-danger">
                        <i className="fas fa-minus-circle"></i>
                      </span>
                                                    </Popconfirm></td>
                                            )
                                        })
                                    }
                                </tr>
                            ))
                            :
                            showNotFound && (<tr className="nodatafound">
                                <td colSpan={tableColumns?.length ? tableColumns.length : 1} className="text-danger">No data
                                    found
                                </td>
                            </tr>)
                    }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AcFilterTable;
